import * as iid from './bookingElementId'
import * as error from '../common/error_strings'
import { RAJESH_TRANSPORT, STA_COMPANY_ID } from '../../helper/companyIdhardcode'
const dummynumbers = ['6666666666', '7777777777', '8888888888', '9999999999']
export const inputChange = (e, inputType, callBack, alertCallback, loginData, findDetailsApi,n,p) => {
  let val = e.target.value
  switch (inputType) {
    case iid.manualLR: {
      val = val.replace(/[^0-9a-zA-Z\-]/g, '')
      callBack(val)
      break
    }
    case iid.sendMobNo:
    case iid.recMobNo: {
      if (dummynumbers.includes(val)) {
        alertCallback(error.SENDER_PHONE, e.target.id)
      } else if (p !== 8 && n + '' === val + '' && val.length) {
        alertCallback('Sender And Reciver Phone Can Not Be Same', e.target.id)
        callBack('')
      } else {
        callBack(val)
        if ((val.length < loginData.MobileNoLLimit || val.length > loginData.MobileNoULimit) && val.length) {
          alertCallback(error.SENDER_PHONE, e.target.id)
        } else {
          const data = {
            strType: inputType === iid.sendMobNo ? 'S' : 'R',
            strMobile: val,
            strName: '',
            intCompanyID: loginData.intCompanyID,
            intBranchID: loginData.intBranchID,
            intUserID: loginData.intUserID,
          }
          if (loginData.intCompanyID !== RAJESH_TRANSPORT) {
            findDetailsApi(data)
          }
        }
      }
      break
    }
    default: {
      return e.target.value
    }
  }
}
export const phonefilter = (number, limit = 10, CompanyID) => {
  const cleanedInput = number.replace(/\D/g, '')
  if (CompanyID !== STA_COMPANY_ID) {
    return cleanedInput
  }
  if (cleanedInput.length <= limit && /^[6-9]/.test(cleanedInput)) {
    return cleanedInput
  } else return ''
}
export const findAndSelectPartyWithNumber = (number, partyList, partySelector, partySelectorArgs = false) => {
  const selectParty = number.length ? partyList.filter((party) => party.MobileNo + '' === number + '') : []
  if (selectParty.length) partySelector(selectParty[0], partySelectorArgs)
}
export const findAndSelectPartyWithID = (PartyID, partyList, partySelector, partySelectorArgs = false) => {
  const selectParty = (PartyID+"").length ? partyList.filter((party) => party.PartyID + '' === PartyID + '') : []
  if (selectParty.length) partySelector(selectParty[0], partySelectorArgs)
}